import {makeAutoObservable} from "mobx";


export const topHeight = 54;
export const openSideWidth = 220;
export const closeSideWidth = 62;

export default class NavigateStore {

    constructor(props) {
        this.sideBarOpen = true;
        makeAutoObservable(this);
    }

    changSideBarOpen = () => {
        this.sideBarOpen = !this.sideBarOpen;
    }
}